class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.bindEvent();
    
    const cartDrawerSubtotalNode = this.querySelector('[mrk-cart-drawer-subtotal]');
    if (cartDrawerSubtotalNode) {
      this.setDiscountOptions(cartDrawerSubtotalNode);
    }

    // 用来判断seal-widget是否显示的定时器，这个内容是第三方加载
    this.sealWidgetTimer = null;
  }

  // 绑定事件
  bindEvent() {
    this.addEventListener('click', (event) => {
      // 点击展开/收起子项
      const cartDrawerSubtotalCollapseNode = event.target.closest('[mrk-cart-drawer-subtotal-collapse]');
      if (cartDrawerSubtotalCollapseNode) {
        const cartDrawerSubtotalNode = cartDrawerSubtotalCollapseNode.closest('[mrk-cart-drawer-subtotal]');
        cartDrawerSubtotalNode.toggleAttribute('open');
        this.setDiscountOptions(cartDrawerSubtotalNode);
        return;
      }
    });
  }

  // 初始话折扣内容是否展示
  setDiscountOptions(cartDrawerSubtotalNode) {
    if (!cartDrawerSubtotalNode) return;
    const cartDrawerSubtotalContentNode = cartDrawerSubtotalNode.querySelector('[mrk-cart-drawer-subtotal-content]');
    if (!cartDrawerSubtotalContentNode) return;

    const isOpen = cartDrawerSubtotalNode.hasAttribute('open');
    const optionsHeight = cartDrawerSubtotalContentNode.scrollHeight;
    if (isOpen) {
      cartDrawerSubtotalContentNode.style.setProperty('height', `${optionsHeight}px`);
    } else {
      cartDrawerSubtotalContentNode.style.setProperty('height', '0');
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    // cartLink.addEventListener('click', (event) => {
    //   event.preventDefault();
    //   this.open(cartLink);
    // });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    
    this.setSealWidgetTimer();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.contains('is-empty') &&
      this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'mrk-product-gift-accessory',
        selector: '.mrk-product-gift-accessory'
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  // seal 插件；服务条款链接
  setSealWidgetTimer() {
    let isMove = false;
    this.sealWidgetTimer = setInterval(() => {
      const sealWidget = this.querySelector('.seal-widget');
      const sealServiceNode = this.querySelector('.seel-service-wpper');
      if (sealServiceNode) {
        if (window.getComputedStyle(sealServiceNode).display !== 'block') {
          isMove = false;
        }
        if (isMove) return; 
        if (sealWidget) {
          if (sealServiceNode) {
            sealServiceNode.style.display = 'block';
            isMove = true;
          }
        } else {
          if (sealServiceNode) {
            sealServiceNode.style.display = 'none';
          }
        }
      }
    }, 2000);
  }
  closeSealWidgetTimer() {
    clearTimeout(this.sealWidgetTimer);
    this.sealWidgetTimer = null;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mrk-product-gift-accessory',
        section: 'mrk-product-gift-accessory',
        selector: '.mrk-product-gift-accessory',
        selectorBox: '.mrk-product-gift-accessory'
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
